import { ImaginusResponseMode } from '../service/imaginus.service';

/** 使用者可選：回覆思考深度（非輸入資料類型；vision／文件／語音由後端路由） */
export type ImaginusThinkingDepthId = 'auto' | 'fast' | 'deep';

/** @deprecated 沿用舊名；僅保留 auto / fast / deep */
export type ImaginusModelProfileId = ImaginusThinkingDepthId;

export interface ImaginusModelOption {
  id: ImaginusThinkingDepthId;
  label: string;
  shortLabel: string;
  hint: string;
  responseMode: ImaginusResponseMode;
  /** 傳給後端的思考深度鍵（非 vision／document 等資料類型） */
  modelKey: string;
}

export const IMAGINUS_MODEL_OPTIONS: ImaginusModelOption[] = [
  {
    id: 'auto',
    label: '自動',
    shortLabel: '自動',
    hint: '依問題長度與複雜度自動選擇回覆深度',
    responseMode: 'simple',
    modelKey: 'auto',
  },
  {
    id: 'fast',
    label: '快速',
    shortLabel: '快速',
    hint: '精簡回覆，適合日常查詢與短問答',
    responseMode: 'simple',
    modelKey: 'qwen2.5:3b',
  },
  {
    id: 'deep',
    label: '深度思考',
    shortLabel: '深度',
    hint: '較完整分析、交叉比對與多步推理',
    responseMode: 'deep',
    modelKey: 'qwen3:14b',
  },
];

export const IMAGINUS_MODEL_PROFILE_STORAGE_KEY = 'imaginus_model_profile';

const LEGACY_MODALITY_PROFILES = new Set(['vision', 'document', 'voice', 'thinking']);

export interface ImaginusModelResolveContext {
  /** 用於 auto 深度推斷（不含附件類型） */
  textLength: number;
}

export function normalizeStoredThinkingDepth(raw: string | null | undefined): ImaginusThinkingDepthId {
  const value = (raw || '').trim().toLowerCase();
  if (value === 'thinking') {
    return 'deep';
  }
  if (LEGACY_MODALITY_PROFILES.has(value)) {
    return 'auto';
  }
  if (IMAGINUS_MODEL_OPTIONS.some((item) => item.id === value)) {
    return value as ImaginusThinkingDepthId;
  }
  return 'auto';
}

export function getImaginusModelOption(id: ImaginusThinkingDepthId): ImaginusModelOption {
  return IMAGINUS_MODEL_OPTIONS.find((item) => item.id === id) ?? IMAGINUS_MODEL_OPTIONS[0];
}

export function resolveImaginusModelProfile(
  selected: ImaginusThinkingDepthId,
  ctx: ImaginusModelResolveContext
): ImaginusModelOption {
  if (selected !== 'auto') {
    return getImaginusModelOption(selected);
  }
  if (ctx.textLength > 180) {
    return getImaginusModelOption('deep');
  }
  return getImaginusModelOption('fast');
}

export function loadStoredModelProfile(): ImaginusThinkingDepthId {
  try {
    const raw = localStorage.getItem(IMAGINUS_MODEL_PROFILE_STORAGE_KEY);
    if (raw) {
      return normalizeStoredThinkingDepth(raw);
    }
    const legacy = localStorage.getItem('imaginus_response_mode');
    if (legacy === 'deep') {
      return 'deep';
    }
  } catch {
    /* ignore */
  }
  return 'auto';
}

export function saveStoredModelProfile(id: ImaginusThinkingDepthId): void {
  try {
    localStorage.setItem(IMAGINUS_MODEL_PROFILE_STORAGE_KEY, id);
  } catch {
    /* ignore */
  }
}
